import React, { useState, useEffect } from 'react'
import ToggleButton from '../CommonComponents/ToggleButton'
import { toast } from '../CommonComponents/ToastComponent/toast'
import { useDispatch } from 'react-redux'
import { testFuseJsSettings } from '../../redux/actions/upload'
import { Table } from 'rsuite'
import LoaderComponent from '../CommonComponents/LoaderComponent'
import { Radio, RadioGroup } from 'rsuite';
import CheckboxComponent from '../CommonComponents/CheckboxComponent'

const { Column, HeaderCell, Cell, Pagination } = Table

const FuseJsSettings = ({ fuseJsBasicSettings, fuseJsFuzzySettings, fuseJsAdvanceSettings, fuseJsKeys, fuseJsOptions, fuseJsSearchKeys, handleSearchKeysChange, handleSettingsChange, onContinue, onGoBack, dataOption, manualSupplierData }) => {
    const tableColumns = [
        {
            name: 'matchStatus',
            label: 'Match Status'
        },
        {
            name: 'suppliername',
            label: 'Supplier Name'
        },
        {
            name: 'address1',
            label: 'Address'
        },
        {
            name: 'city',
            label: 'City'
        },
        {
            name: 'state',
            label: 'State'
        },
        {
            name: 'zip',
            label: 'Zip'
        },
        {
            name: 'email',
            label: 'Email'
        },
        {
            name: 'phone',
            label: 'Phone'
        },
        {
            name: 'employerIdNumber',
            label: 'EIN'
        },
        {
            name: 'score',
            label: 'Score'
        },
        {
            name: 'matchedId',
            label: 'Matched Id'
        },
        {
            name: 'matchedSuppliername',
            label: 'Matched Suppliername'
        },
        {
            name: 'matchedAddress',
            label: 'Matched Address'
        },
        {
            name: 'matchedCity',
            label: 'Matched City'
        },
        {
            name: 'matchedState',
            label: 'Matched State'
        },
        {
            name: 'matchedZip',
            label: 'Matched Zip'
        },
        {
            name: 'matchedPhone',
            label: 'Matched Phone'
        },
        {
            name: 'matchedEmail',
            label: 'Matched Email'
        },
        {
            name: 'matchedEIN',
            label: 'Matched EIN'
        },
        {
            name: 'esscore',
            label: 'ES Score'
        },
        {
            name: 'esmatchedId',
            label: 'ES Matched Id'
        },
        {
            name: 'esmatchedSuppliername',
            label: 'ES Matched Suppliername'
        },
        {
            name: 'esmatchedAddress',
            label: 'ES Matched Address'
        },
        {
            name: 'esmatchedCity',
            label: 'ES Matched City'
        },
        {
            name: 'esmatchedState',
            label: 'ES Matched State'
        },
        {
            name: 'esmatchedZip',
            label: 'ES Matched Zip'
        },
        {
            name: 'esmatchedPhone',
            label: 'ES Matched Phone'
        },
        {
            name: 'esmatchedEmail',
            label: 'ES Matched Email'
        },
        {
            name: 'esmatchedEIN',
            label: 'ES Matched EIN'
        }
    ]

    const esTableColumns = [
        {
            name: 'suppliername',
            label: 'Supplier Name'
        },
        {
            name: 'address1',
            label: 'Address'
        },
        {
            name: 'city',
            label: 'City'
        },
        {
            name: 'state',
            label: 'State'
        },
        {
            name: 'zip',
            label: 'Zip'
        },
        {
            name: 'email',
            label: 'Email'
        },
        {
            name: 'phone',
            label: 'Phone'
        },
        {
            name: 'employerIdNumber',
            label: 'EIN'
        },
        {
            name: 'esscore',
            label: 'ES Score'
        },
        {
            name: 'esmatchedId',
            label: 'ES Matched Id'
        },
        {
            name: 'esmatchedSuppliername',
            label: 'ES Matched Suppliername'
        },
        {
            name: 'esmatchedAddress',
            label: 'ES Matched Address'
        },
        {
            name: 'esmatchedCity',
            label: 'ES Matched City'
        },
        {
            name: 'esmatchedState',
            label: 'ES Matched State'
        },
        {
            name: 'esmatchedZip',
            label: 'ES Matched Zip'
        },
        {
            name: 'esmatchedPhone',
            label: 'ES Matched Phone'
        },
        {
            name: 'esmatchedEmail',
            label: 'ES Matched Email'
        },
        {
            name: 'esmatchedEIN',
            label: 'ES Matched EIN'
        }
    ]

    const dispatch = useDispatch()
    const [isProgress, setIsProgress] = useState(false)
    const [resultData, setResultData] = useState([])
    const [isRunEsMatch, setIsRunEsMatch] = useState(false)
    const [isUseFullAddressMatch, setIsUseFullAddressMatch] = useState(false)

    const handleContinueClick = (isRunEsMatch = false) => {
        setIsRunEsMatch(isRunEsMatch)
        let isEmptyValues = Object.entries(fuseJsSearchKeys).filter(([ind, val], i) => !val.weight)
        if (isEmptyValues && isEmptyValues.length > 0) {
            toast.show({
                title: 'Warning',
                description: 'Search keys weight shpuldn\'t be empty and must be greater than zero!'
            })
            return
        }
        if (dataOption !== 'manual') {
            onContinue('preview', isRunEsMatch, isUseFullAddressMatch)
        } else {
            setIsProgress(true)
            const options = { ...fuseJsOptions }
            let keys = [...fuseJsSearchKeys]
            keys = keys.sort(function (a, b) {
                return b.weight - a.weight;
            });

            options['keys'] = keys
            let tableData = [{
                supplier: {
                    'suppliername': manualSupplierData?.suppliername,
                    'address1': manualSupplierData?.address1,
                    'city': manualSupplierData?.city,
                    'state': manualSupplierData?.state,
                    'zip': manualSupplierData?.zip,
                    'phone': manualSupplierData?.phone,
                    'email': manualSupplierData?.email,
                    'abbreviatedState': manualSupplierData?.abbreviatedState,
                    'employerIdNumber': manualSupplierData?.employerIdNumber,
                    // 'fullAddress': manualSupplierData?.fullAddress || ''
                }
            }]
            dispatch(testFuseJsSettings({
                data: tableData,
                fuseJsOptions: options,
                isRunEsMatch: isRunEsMatch,
                isUseFullAddressMatch: isUseFullAddressMatch
            })).then(result => {
                setIsProgress(false)
                setResultData([result?.[0]?.data])
            }).catch(err => {
                setIsProgress(false)
            })
        }
    }

    const headerElements = isRunEsMatch ? esTableColumns.map((col, index) => {
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell className='text-black' dataKey={col.name} />
            </Column>
        )
    }) : tableColumns.map((col, index) => {
        return (
            <Column
                resizable
                sortable
                key={col.name}
            >
                <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                <Cell className='text-black' dataKey={col.name} />
            </Column>
        )
    })

    return (
        <>
            <div className={`position-relative d-flex mb-5`}>
                <button type="button" className="text-white p-5 pt-3 pb-3 rounded h4 mb-0 bg-gray back" onClick={() => { dataOption !== 'manual' ? onGoBack('match') : onGoBack('upload') }}>
                    Go Back
                </button>
                <button type="button" className="text-white p-5 pt-3 pb-3 rounded h4 mb-0  bg-green continue ms-auto" onClick={() => handleContinueClick()}>
                    Confirm
                </button>
                <button type="button" className="text-white p-5 pt-3 pb-3 rounded h4 mb-0  bg-green continue ms-auto" onClick={() => handleContinueClick(true)}>
                    Run ES Match
                </button>
            </div>
            <div className={`position-relative ${isProgress ? 'loading' : ''}`}>
                {isProgress && <LoaderComponent />}
                {resultData && resultData.length > 0 && (
                    <div className='result-table mt-5 mb-5'>
                        <h4 className='text-black mb-0 fw-bold'>Test Result Data</h4>
                        <div className='mt-4 border border-2 rounded'>
                            <Table
                                virtualized={true}
                                autoHeight
                                affixHeader={true}
                                data={resultData}
                            >
                                {headerElements}
                            </Table>
                        </div>
                    </div>
                )}

                <div className='d-flex flex-column gap-4 rounded border p-5 mb-5'>
                    <CheckboxComponent
                        label='Do you want to use Full Address Match?'
                        onChange={(checked) => { setIsUseFullAddressMatch(checked) }}
                        checked={isUseFullAddressMatch || false}
                    />
                </div>

                <div className='d-flex flex-column gap-4 rounded border p-5 mb-5'>
                    <h2 className='w-25 text-blue fw-bold mb-4'><i>Search Keys Weight:</i></h2>
                    {fuseJsKeys.map((key, ind) => {
                        return (
                            <div key={ind} className='d-flex align-items-center justify-content-center'>
                                <h4 className='w-25 text-black fw-bold mb-0'>{key.label}</h4>
                                <input className='search-input h4 mb-0' type='number' min="1" step="1" value={fuseJsSearchKeys?.[ind]['weight']} onChange={(event) => handleSearchKeysChange(key.name, event.target.value)} />
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className='fuse-js-settings rounded d-flex flex-column'>
                <div className='fuse-js-basic-settings border border-1 rounded p-5 d-flex flex-column gap-4'>
                    <h2 className='text-blue fw-bold mb-4'><i>Basic Settings:</i> </h2>
                    {fuseJsBasicSettings.map((setting, index) => {
                        return (
                            <div key={index} className='d-flex align-items-center justify-content-center'>
                                <h4 className='w-25 text-black fw-bold mb-0'>{setting.label}</h4>
                                {setting.dataType === 'boolean' ?
                                    <div className='w-100'>
                                        <ToggleButton checked={fuseJsOptions?.[setting.name]} onChange={(checked) => handleSettingsChange(setting.name, checked, setting.dataType)} />
                                    </div>
                                    :
                                    setting.dataType === 'radio' ?
                                        <div className='d-flex align-items-center w-100'>
                                            <RadioGroup name="radioList" className='flex' inline={true} value={fuseJsOptions?.[setting.name]}>
                                                <Radio className='h4 mb-0 text-black' value="or" onChange={() => { handleSettingsChange(setting.name, 'or', setting.dataType) }}>Or</Radio>
                                                <Radio className='h4 mb-0 text-black' value="and" onChange={() => { handleSettingsChange(setting.name, 'and', setting.dataType) }}>And</Radio>
                                            </RadioGroup>
                                        </div>
                                        :
                                        <input className='search-input h4 mb-0' type={setting.dataType} value={fuseJsOptions?.[setting.name]} onChange={(event) => handleSettingsChange(setting.name, event.target.value, setting.dataType)} min={'0'} />
                                }
                            </div>
                        )
                    })}
                </div>
                <div className='fuse-js-fuzzy-matching-settings mt-5 border border-1 rounded p-5 d-flex flex-column gap-4'>
                    <h2 className='text-blue fw-bold mb-4'> <i>Fuzzy Matching Settings:</i> </h2>
                    {fuseJsFuzzySettings.map((setting, index) => {
                        return (
                            <div key={index} className='d-flex align-items-center justify-content-center'>
                                <h4 className='w-25 text-black fw-bold mb-0'>{setting.label}</h4>
                                {setting.dataType === 'boolean' ?
                                    <div className='w-100'>
                                        <ToggleButton checked={fuseJsOptions?.[setting.name]} onChange={(checked) => handleSettingsChange(setting.name, checked, setting.dataType)} />
                                    </div>
                                    :
                                    <input className='search-input h4 mb-0' type={setting.dataType} value={fuseJsOptions?.[setting.name]} onChange={(event) => handleSettingsChange(setting.name, event.target.value, setting.dataType)} min="0.0" max={setting.name === 'threshold' ? '1' : ''} step={setting.name === 'threshold' ? '0.1' : 'any'} />
                                }
                            </div>
                        )
                    })}
                </div>
                <div className='fuse-js-advance-settings mt-5 border border-1 rounded p-5 d-flex flex-column gap-4'>
                    <h2 className='text-blue fw-bold mb-4'> <i> Advance Settings: </i></h2>
                    {fuseJsAdvanceSettings.map((setting, index) => {
                        return (
                            <div key={index} className='d-flex align-items-center justify-content-center'>
                                <h4 className='w-25 text-black fw-bold mb-0'>{setting.label}</h4>
                                {setting.dataType === 'boolean' ?
                                    <div className='w-100'>
                                        <ToggleButton checked={fuseJsOptions?.[setting.name]} onChange={(checked) => handleSettingsChange(setting.name, checked, setting.dataType)} />
                                    </div>
                                    :
                                    <input className='search-input h4 mb-0' type={setting.dataType} value={fuseJsOptions?.[setting.name]} onChange={(event) => handleSettingsChange(setting.name, event.target.value, setting.dataType)} min={'0'} step='0.1' />
                                }
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default FuseJsSettings